export default __webpack_public_path__ + "static/media/pgmico(25).4a3d6f05.png";